import React, { useState } from 'react';
import Button from '../components/Button/Button';
import { userLogin } from '../services/authApi';
import { toast } from 'react-toastify';
import useFormValidation from '../hooks/useFormValidation';
import { IoEye, IoEyeOff } from "react-icons/io5";
import { loginFormValidationSchema } from '../utils/formValidation';
import { AiOutlineLoading } from 'react-icons/ai';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const base_url = process.env.REACT_APP_BASE_URL

const LoginSingleRoom = () => {
    const [formData, setFormData] = useState({ username: "", password: "" });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { errors, validateAllFields } = useFormValidation(loginFormValidationSchema);
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();
    const handleToggle = () => {
        setShowPassword(!showPassword);
    }

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [id]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        const includeFields = Object.keys(formData);
        if (validateAllFields(formData, includeFields)) {
            try {
                const response = await userLogin(formData);
                if (response && typeof (response) !== 'object') {
                    if(response === "Invalid credentials"){
                        toast.error(t("login.invalidCredentials"));
                    }else{
                        toast.error(t("login.invalidUsername"))
                    }    
                } else {
                    toast.success( t("login.loginSuccess") );
                    setTimeout(() => {
                        navigate(`${base_url}/change_to_single_room`);
                        window.location.reload();
                    }, 500);

                }
            } catch (error) {
                toast.error(error);
            } finally {
                setIsSubmitting(false);
            }
        } else {
            toast.error( t("general.ValidationFail") );
            setIsSubmitting(false);
        }
    };
    const { t } = useTranslation();
    return (
        <>
            <div className='form-wrapper d-flex flex-column'>
                <h3 className='mt-5 d-flex justify-content-center'>{t("login.title")}</h3>
                <p className='d-flex justify-content-center text-center'>{t("login.description")}</p>
                <form onSubmit={handleSubmit}>
                    <div className="form-item d-flex justify-content-center mb-3">
                        <input type="text" value={formData.username} className="form-control" id="username" placeholder={t("login.username")} onChange={handleInputChange} required />
                    </div>
                    {errors.username && <span className="error">{errors.username}</span>}
                    <div className="password-input">
                        <input
                            type={showPassword ? "text" : "password"}
                            value={formData.password} className="form-control"
                            id="password"
                            placeholder={t("login.password")}
                            onChange={handleInputChange}
                            required
                        />
                        <span className="position-absolute eye-icon" onClick={handleToggle}>
                            {showPassword ?
                                <IoEye className='absolute' />
                                :
                                <IoEyeOff className='absolute' />
                            }
                        </span>
                    </div>
                    {errors.password && <span className="error">{errors.password}</span>}
                    <div className='submit-button mt-4 d-flex justify-content-center'>
                        <Button buttonStyle='btn--primary' disabled={isSubmitting} type="submit">
                            {isSubmitting ? <AiOutlineLoading className="spin" /> : t('login.save')}
                        </Button>
                    </div>
                </form>
            </div>
        </>
    )
}

export default LoginSingleRoom